/**
 * @type {import("../components/KBDropdown").KBDropdownOption[]}
 */
export const PROCESS_TYPE_OPTIONS = [
    {
        label: 'L1',
        value: 'l1',
    },
    {
        label: 'L2',
        value: 'l2',
    },
];
/**
 * @type {import("../components/KBDropdown").KBDropdownOption[]}
 */
export const PROCESS_FILTER_OPTIONS = [
    {
        label: 'New',
        value: 'unprocessed',
    },
    {
        label: 'Failed',
        value: 'failed',
    },
    {
        label: 'All',
        value: '',
    },
];
export const L2_PROCESS_FILTER_OPTIONS = [
    {
        label: 'All',
        value: '',
    },
];
/**
 * @type {import("../components/KBDropdown").KBDropdownOption[]}
 */
export const CONTEXTUAL_RETRIEVAL_OPTIONS = [
    {
        label: 'None',
        value: 'none',
        tooltip: 'Disables contextual retrieval, resulting in the fastest processing but the lowest retrieval accuracy.',
    },
    {
        label: 'Global Augmentation (GA)',
        value: 'GLOBAL',
        tooltip: 'Balances speed and accuracy by augmenting chunks with high-level, document-specific context.',
    },
    {
        label: 'Global Local Augmentation (GLA)',
        value: 'GLOBALLOCAL',
        tooltip: 'Maximizes retrieval accuracy by augmenting chunks with both high-level and local context, requiring slower processing.',
    },
];

/**
 * @type {import("../components/KBDropdown").KBDropdownOption[]}
 */
export const VECTOR_DATABASE_OPTIONS = [
    {
        label: 'MongoDB',
        value: 'MongoDB',
    },
    {
        label: 'Milvus',
        value: 'Milvus',
    },
];
/**
 * @type {import("../components/KBDropdown").KBDropdownOption[]}
 */
export const VECTOR_DIMENSIONS_OPTIONS = [
    {
        label: '1024',
        value: 1024,
    },
    {
        label: '256',
        value: 256,
    },
];
/**
 * @type {import("../components/KBDropdown").KBDropdownOption[]}
 */
export const EMBEDDING_MODEL_OPTIONS = [
    {
        label: 'Jina',
        value: 'jina',
    },
];
/**
 * @type {import("../components/KBDropdown").KBDropdownOption[]}
 */
export const CHUNKING_STRATEGY_OPTIONS = [
    {
        label: 'By Page',
        value: 'by page',
    },
];

/**
 * @type {import("../components/KBDropdown").KBDropdownOption[]}
 */
export const SEARCH_TYPE_OPTIONS = [
    {
        label: 'Vector',
        value: 'vector',
        disabled: false,
    },
    {
        label: 'File',
        value: 'file',
        disabled: false,
    },
    {
        label: 'Enhanced Vector',
        value: 'enhanced_vector',
        disabled: true,
    },
    {
        label: 'Hybrid',
        value: 'hybrid',
        disabled: true,
    },
    {
        label: 'Keyword',
        value: 'keyword',
        disabled: true,
    },
];
